<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center">Orden de Comercio #{{ id }}</h1></div>
    </div>

    @if (error()) {
        <div class="alert alert-danger mt-2 mx-3" role="alert"><small>{{ error() }}</small></div>
    }
    @if (message()) {
        <div class="alert alert-success mt-2 mx-3" role="alert"><small>{{ message() }}</small></div>
    }

    @if (orden(); as o) {
        <div class="row-cols-12 m-2 mt-0">
            <div class="detalle-card mt-2">
                <div class="detalle-section-title">Estado</div>
                <div class="d-flex align-items-center gap-2">
                    <select
                        class="form-select form-select-sm orden-estado-select"
                        [disabled]="guardando()"
                        (change)="onEstadoSeleccionadoChange($any($event.target).value)"
                    >
                        @for (estado of estadosOrdenes(); track estado.id) {
                            <option [value]="estado.id" [selected]="estado.id === o.id_estado_orden">
                                {{ estado.x_descripcion }}
                            </option>
                        }
                    </select>
                    <button
                        type="button"
                        class="btn-guardar-estado"
                        [disabled]="!hayCambiosSinGuardar || guardando()"
                        (click)="guardarEstado()"
                    >
                        @if (guardando()) {
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        } @else {
                            Guardar
                        }
                    </button>
                </div>
            </div>

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Personas</div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-person"></i> Cliente</span>
                    <a class="detalle-value" [routerLink]="['/perfil-cliente', o.id_cliente]">{{ o.nombreCliente || 'Sin nombre' }}</a>
                </div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-shop"></i> Comercio</span>
                    <a class="detalle-value" [routerLink]="['/perfil-comercio', o.id_comercio]">{{ o.nombreComercio || 'Sin nombre' }}</a>
                </div>
            </div>

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Productos y medicamentos</div>
                @for (item of items(); track $index) {
                    <div class="item-row">
                        <div class="item-info">
                            <div class="item-nombre">{{ item.nombre }} <span class="item-cant">x{{ item.cantidad }}</span></div>
                            @if (item.detalle) {
                                <div class="item-detalle">{{ item.detalle }}</div>
                            }
                            @if (item.porcentajeDescuento > 0) {
                                <div class="item-descuento">{{ item.porcentajeDescuento }}% off · antes {{ item.precio | currency:'ARS' }}</div>
                            }
                        </div>
                        <div class="item-subtotal">{{ item.subtotal | currency:'ARS' }}</div>
                    </div>
                } @empty {
                    <div class="text-muted small">No se encontraron productos para esta orden.</div>
                }

                <hr class="mt-2 mb-2">

                <div class="detalle-row">
                    <span class="detalle-label">Subtotal</span>
                    <span class="detalle-value">{{ (total() + ahorro()) | currency:'ARS' }}</span>
                </div>
                @if (ahorro() > 0) {
                    <div class="detalle-row">
                        <span class="detalle-label">Ahorro por descuentos</span>
                        <span class="detalle-value text-success">- {{ ahorro() | currency:'ARS' }}</span>
                    </div>
                }
                @if (o.n_precio_envio) {
                    <div class="detalle-row">
                        <span class="detalle-label">Envío</span>
                        <span class="detalle-value">{{ o.n_precio_envio | currency:'ARS' }}</span>
                    </div>
                }
                <div class="detalle-row">
                    <span class="detalle-label fw-bold">Total</span>
                    <span class="detalle-value fw-bold">{{ (total() + (o.n_precio_envio || 0)) | currency:'ARS' }}</span>
                </div>
            </div>

            <div class="detalle-card mt-3">
                <div class="detalle-section-title">Entrega y pago</div>
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-truck"></i> Entrega</span>
                    <span class="detalle-value">{{ formaEntrega }}</span>
                </div>
                @if (o.n_tiempo_envio) {
                    <div class="detalle-row">
                        <span class="detalle-label">Tiempo estimado</span>
                        <span class="detalle-value">{{ o.n_tiempo_envio }} min</span>
                    </div>
                }
                <div class="detalle-row">
                    <span class="detalle-label"><i class="bi bi-credit-card"></i> Forma de pago</span>
                    <span class="detalle-value">{{ formaPago }}</span>
                </div>
            </div>

            @if (o.x_notas) {
                <div class="detalle-card mt-3">
                    <div class="detalle-section-title">Notas</div>
                    <div class="detalle-notas">{{ o.x_notas }}</div>
                </div>
            }

            <div class="detalle-card mt-3 mb-4">
                <div class="detalle-section-title">Fechas de la orden</div>
                <div class="detalle-row"><span class="detalle-label">Creada</span><span class="detalle-value">{{ o.d_date_create ? (o.d_date_create | date:'dd/MM/yyyy HH:mm') : '-' }}</span></div>
                <div class="detalle-row"><span class="detalle-label">Última actualización</span><span class="detalle-value">{{ o.d_date_updated ? (o.d_date_updated | date:'dd/MM/yyyy HH:mm') : '-' }}</span></div>
            </div>
        </div>
    }
</div>
